import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from '../../helpers';

const selectors = {
  productImage: '[data-product-image]',
  mainCarousel: '[data-image-carousel]',
  thumbnailCarousel: '[data-thumbnail-carousel]',
};

/**
 * Product image gallery on the PDP
 *
 * @export
 * @class ProductImages
 */
export default class ProductImages {
  constructor(el) {
    this.el = el;
    this.mainCarouselEl = el.querySelector(selectors.mainCarousel);
    this.thumbnailCarouselEl = el.querySelector(selectors.thumbnailCarousel);
    this.navItems = this.thumbnailCarouselEl.querySelectorAll(
      selectors.productImage,
    );
    this._initCarousel();
  }

  /**
   * Initialize primary image carousel
   */
  _initCarousel() {
    this.mainCarousel = new Splide(this.mainCarouselEl, {
      perPage: 1,
      // Below lg the thumbnail rail is hidden, so the dots are the only cue
      // that there is more than one image to swipe through. From lg up the
      // rail says the same thing and Splide drops them again.
      pagination: true,
      arrows: false,
      mediaQuery: 'min',
      speed: 600,
      breakpoints: {
        [unitlessBreakpoints.lg]: {
          pagination: false,
        },
      },
    });

    this.thumbnailCarousel = new Splide(this.thumbnailCarouselEl, {
      destroy: true,
      fixedWidth: 90,
      fixedHeight: 'auto',
      gap: 6,
      pagination: false,
      arrows: true,
      isNavigation: true,
      wheel: true,
      wheelSleep: 600,
      speed: 600,
      waitForTransition: true,
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.lg]: {
          destroy: false,
          direction: 'ttb',
          height: 'auto',
        },
      },
    });

    this.mainCarousel.sync(this.thumbnailCarousel);
    this.mainCarousel.mount();
    this.thumbnailCarousel.mount();
  }

  /**
   * Handler for swapping images when the variant changes
   *
   * @param {Object} variant The currently selected variant
   * @public
   */
  change(variant) {
    this.navItems.forEach((element, index) => {
      const { imageVariants } = element.dataset;
      // Bail if array of variants for this image
      // doesn't contain currently selected variant id
      if (!imageVariants.split(',').includes(String(variant.id))) {
        return;
      }

      this.mainCarousel.go(index);
    });
  }
}
